import { render, staticRenderFns } from "./addInvoice.vue?vue&type=template&id=5516621b&scoped=true"
import script from "./addInvoice.vue?vue&type=script&lang=js"
export * from "./addInvoice.vue?vue&type=script&lang=js"
import style0 from "./addInvoice.vue?vue&type=style&index=0&id=5516621b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516621b",
  null
  
)

export default component.exports